export const PLATFORM_BRAND_KIT_FONT_WEIGHTS = [
  'weight_100',
  'weight_200',
  'weight_300',
  'weight_400',
  'weight_500',
  'weight_600',
  'weight_700',
  'weight_800',
  'weight_900'
];

export const PLATFORM_BRAND_KIT_KEYS = ['web_font', ...PLATFORM_BRAND_KIT_FONT_WEIGHTS] as const;

export enum PlatformBrandKitTabs {
  BRAND_KIT = 'BRAND_KIT',
  CUSTOM = 'CUSTOM'
}
